export default {
  DEFAULT: 'xgplayer',
  DEFAULT_SKIN: 'xgplayer-skin-default',
  ENTER: 'xgplayer-is-enter',
  PAUSED: 'xgplayer-pause',
  PLAYING: 'xgplayer-playing',
  ENDED: 'xgplayer-ended',
  CANPLAY: 'xgplayer-canplay',
  LOADING: 'xgplayer-isloading',
  ERROR: 'xgplayer-is-error',
  REPLAY: 'xgplayer-replay',
  NO_START: 'xgplayer-nostart',
  ACTIVE: 'xgplayer-active',
  INACTIVE: 'xgplayer-inactive',
  FULLSCREEN: 'xgplayer-is-fullscreen',
  CSS_FULLSCREEN: 'xgplayer-is-cssfullscreen',
  ROTATE_FULLSCREEN: 'xgplayer-rotate-fullscreen',
  PARENT_ROTATE_FULLSCREEN: 'xgplayer-rotate-parent',
  PARENT_FULLSCREEN: 'xgplayer-fullscreen-parent',
  INNER_FULLSCREEN: 'xgplayer-fullscreen-inner',
  NO_CONTROLS: 'no-controls',
  FLEX_CONTROLS: 'flex-controls',
  CONTROLS_FOLLOW: 'controls-follow',
  CONTROLS_AUTOHIDE: 'controls-autohide',
  TOP_BAR_AUTOHIDE: 'top-bar-autohide',
  NOT_ALLOW_AUTOPLAY: 'not-allow-autoplay',
  SEEKING: 'seeking',
  PC: 'xgplayer-pc',
  MOBILE: 'xgplayer-mobile',
  MINI: 'xgplayer-mini' // mini screen play status
}
